
import React, { useContext } from 'react';
import { Layers, RefreshCw } from 'lucide-react';
import { AppContext } from '../App.tsx';

const Header: React.FC = () => {
  const ctx = useContext(AppContext);

  return (
    <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center shadow-lg shadow-indigo-500/20">
            <Layers className="text-white" size={24} />
          </div>
          <div>
            <h1 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400">
              Sketch2Code Mastermind
            </h1>
            <p className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">
              Expert 3-Engine AI Pipeline
            </p>
          </div>
        </div>
        
        <button 
          onClick={() => ctx?.dispatch({ type: 'RESET' })}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 border border-slate-700 transition-colors text-sm font-medium text-slate-300"
        >
          <RefreshCw size={16} />
          Reset Pipeline
        </button>
      </div>
    </header>
  );
};

export default Header;
